// Filename - components/ShowVideo.js

import React  from "react";


export default function ShowVideo ({embedid}){

   if(!embedid){
      return (
         <div>
            <p> No video to show!</p>
         </div>
      )
   }

    return (
      <div className="text-center m-3">
         <iframe 
            width="560" 
            height="315" 
            src={`https://www.youtube.com/embed/${embedid}?controls=0&modestbranding=1`}
         >
         </iframe>
      </div>
  
    )

}
